import React, {Component} from 'react';
import { Flex, Link, Button } from "../../components";
import styled from 'styled-components';
//import { Redirect } from 'react-router-dom';
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
import 'chartist-plugin-axistitle';
import 'chartist/dist/chartist.min.css'
import 'chartist-plugin-pointlabels';

// 959292c9
// aca9a9b0

const Polygon = styled(Flex)`
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3.6em;
    height: 2.6em;
    // cursor: pointer;
    text-decoration: none;
    
      color: black;
      z-index: 1;
  }

  svg {
    position: absolute;
    width: 80%;
    height: 32px;
    polygon {
    //   stroke: #d6d4d4;
    //   stroke-width: 10px;
      transition: all 0.3s esae;
      border: 1px solid black;
    }
    transition: all 0.3s esae;
    // border: 1px solid black;
  }
`;
let TopicBar = styled.div`
  border: 1px transparent black;
  border-radius: 5px;
  padding: 0.05em;
  display: flex;
  width: 70%;
  margin: auto;
  flex-direction: row;
  margin-bottom: 8px; 
  background: linear-gradient(to right, ${({ colour }) => colour} ${({ colorWidth }) => colorWidth}%, #aca9a9b0 ${({ greyColorWidth }) => greyColorWidth}%);
`

const StyledHeadings = styled.h3`
    text-align: center;
    font-size: 16px;
    font-weight: 900;
    color: black; 
`
const SecondaryHeading = styled.p`
  text-align: center;
  font-size: 14px;
  color: #888787;
  margin-bottom: 15px;
  font-weight: 500;
  margin-left: 20px;
  margin-right: 20px;

`
// style={{ color: '#827e7e', fontSize: '14px', marginBottom: '20px', textAlign: 'center'}}
const Badge = () => (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 500 50" >
      <polygon points="0,0 70,0 70,40 40,40 35,50 30,40 0,40" fill='none' stroke='black' />
    </svg>
  );

class TestAnalysis extends Component {
  componentDidMount = () => {
    let questions = this.props.response.time_per_question;
    let timeSeries1 = [];
    let timeSeries2 = [];
    let count = 0;
    let labelsArray = [];
    questions.map((question)=> {
      timeSeries1.push(question.timetaken)
      timeSeries2.push(question.time_spent_per_question)
      count = count +1;
      labelsArray.push(count)
    })
  
    let answers=this.props.questions;
    let data = {
      series: [timeSeries1, timeSeries2],
      labels: labelsArray
    }
    console.log(data)
      
      let options =  {
          fullWidth: true,
          height: 250,
          horizontalBars: false,
          seriesBarDistance: 8,
          chartPadding: {
            right: 20,
            left: -40
          }, plugins: [
            Chartist.plugins.ctAxisTitle({
              axisX: {
                axisTitle: 'Questions',
                axisClass: 'ct-axis-title',
                offset: {
                  x: 0,
                  y: 45
                },
                textAnchor: 'middle'
              },
              axisY: {
                axisTitle: 'Time spent (in sec)',
                axisClass: 'ct-axis-title',
                offset: {
                  x: 0,
                  y: 15
                },
                textAnchor: 'middle',
                flipTitle: true
              }
            })
          ],
          axisX: {
            axisTitle: "Questions",
            gridThickness: 1,
            tickLength: 20,
            // scaleMinSpace: difference,
            offset: 45,
            // scaleMinSpace: 10,
    
            low: 0
          },
          axisY: {
            offset: 105,
            low: 0,
            labelOffset:{
              y: 4
            }
          }
        };

      let chart = new Chartist.Bar('#ct-chart', data,options)
      chart.on('draw', function (data) {
        if (data.type === 'grid' && data.index !== 0) {
          data.element.remove();
        }
        if(data.type === 'bar' && data.seriesIndex !==1) {
          let is_correct = answers[data.index].correctly_answered === 1 ? true : false;
          let color = is_correct ? '#328c44' : '#e65555'
          // let color = '#e8554e';
          console.log(is_correct)
          data.element.attr({
            style: `stroke: ${color}`
          })
        }
      });

    }
  render () {
    // let colours = ['#45eeac', '#f65757f2', '#51a3e8', '#f45589', '#e4734e', '#95ea47', '#f8b840', '#28eaea', '#ea8ece', '#9585f6b5', '#7bf1f6', '#ec66a4', '#43ec67', '#1734fe9e', '#d1fe179e']
    let coloursDark = ['#16724e', '#c52f2ff2', '#0a73cb', '#e22764', '#fa5721', '#59a216', '#ae760e', '#08d1d1', '#d50997', '#3215e2b5', '#15777b', '#ec66a4', '#43ec67', '#1734fe9e', '#d1fe179e']
    let response = this.props.response;
    console.log(response)
    let chartWidth = response.total_questions_count <= 10 ? '100%' : response.total_questions_count <= 15 ? '120%' : '150%';
    let rankArray = response.rank.split('/')
    let totalStudents = +rankArray[1]
    return (
      <div>
        <div className='timeAnalysis' style={{WebkitOverflowScrolling: 'touch'}}>
          <div className='analysisLegendHeading'>
            <StyledHeadings>TIME ANALYSIS </StyledHeadings>
            <SecondaryHeading>Understanding and Comparing your time utilization patterns</SecondaryHeading>
            <div className='timeAnalysisLegend'>
              <div className='legendColorWidth'><div className='legendColor correct'></div></div>
              <div className='legendColorWidth'><p className='legendDetails'>&nbsp;-&nbsp;</p></div>
              <div className='legendDataWidth'><p className='legendDetails'> Your time for correctly answered</p></div>
            </div>
            <div className='timeAnalysisLegend'>
              <div className='legendColorWidth'><div className='legendColor incorrect'></div></div>
              <div className='legendColorWidth'><p className='legendDetails'>&nbsp;-&nbsp;</p></div>
              <div className='legendDataWidth'><p className='legendDetails'> Your time for incorrectly answered</p></div>
            </div>
            <div className='timeAnalysisLegend'>
              <div className='legendColorWidth'><div className='legendColor average'></div></div>
              <div className='legendColorWidth'><p className='legendDetails'>&nbsp;-&nbsp;</p></div>
              <div className='legendDataWidth'><p className='legendDetails'>Average time spent by the students who answered correctly</p></div>
            </div>
          </div>
          <div className='chartDiv' style={{WebkitOverflowScrolling: 'auto'}}>
              <div id='ct-chart'></div>
          </div>
        </div> 
        
        <div className = 'topicAnalysis' style={{WebkitOverflowScrolling: 'auto'}}>
          <StyledHeadings>TOPIC WISE ANALYSIS</StyledHeadings>
          <SecondaryHeading>Review your performance in each topic</SecondaryHeading>
          <div className='topicAnalysisLegend'>
            <div className='topicLegendDiv'>
              <div className='performanceLegendColor'></div>
              <p className='performanceLegendData'> &nbsp;&nbsp;- Your performance</p>
            </div>
            <div className='topicLegendDiv'>
              <div className='averageColorLegend'></div>
              <p className='performanceLegendData'> &nbsp;&nbsp;- Average class performance</p>
            </div>
          </div>
          {response.topicWise_data.map(
            ({ name, correct_questions_count, total_questions_count,student_correct_questions_count }, i) => {
              let colour = coloursDark[i]
              let percentage = parseFloat(( correct_questions_count/ total_questions_count) * 100).toFixed(0);
            // let percentage = 100;
              let averagePercentage = parseFloat(( student_correct_questions_count/ (total_questions_count* totalStudents)) * 100).toFixed(0);
              console.log(averagePercentage)
            return <div > 
              <div className='analysisDiv'>
                <div style ={{width: '40%'}}>
                  <p className='topicName'>{name}</p>
                </div>
                <div className='analysisBars'>
                  <div className='analysisPercentage'>
                    <div style={{width: percentage+'%', backgroundColor: '#216381', height: '10px', marginTop: '2px'}}>
                    </div>
                    <div style ={{width: (100 -percentage) +'%'}}>
                      <p className='analysisPercentageValue'>
                        {percentage}%
                      </p>
                    </div>
                  </div>
                  <div className='analysisPercentage'>
                    <div style={{width: averagePercentage+'%', backgroundColor: '#ffa600',height: '10px'}}>

                    </div>
                    <div style ={{width: (100 - averagePercentage) + '%'}}>
                      <p className='analysisAveragePercentageValue'>
                        {averagePercentage}%
                      </p>
                    </div>
                  </div>

                </div>
              </div>
              </div>
            }
          )}
        </div>
        
          <style jsx='true' scoped>{`
            .analysisAveragePercentageValue{
              margin: 0 0.6em;
              font-weight: 500;
              font-size: 10px;
              line-height: 1;
              color: black;
              width: 15%;
            }
            .analysisPercentageValue{
              margin: 0 0.6em;
              font-weight: 500;
              font-size: 10px;
              color: black;
              width: 15%;
            }
            .analysisPercentage{
              display: flex;
              flex-direction: row;
            }
            .analysisBars{
              display: flex;
              flex-direction: column;
              width: 60%;
              padding: 5px;
            }
            .analysisDiv{
              display: flex;
              flex-direction: row;
              margin: 5px auto;
              width: 92%;
              padding-right: 10px;
            }
            .topicAnalysisLegend{
              display: flex;
              flex-direction: column;
              text-align: center;
              margin: 10px auto 20px 50px;
              width: 70%;
            }
            .performanceLegendColor{
              background-color: #216381;
              width: 8px;
              height: 8px;
              margin-top: 5px;
            }
            .topicName{
              margin: 0.2em 0.8em;
              font-weight: 500;
              font-size:12px;
              color: black;
              padding-right: 10px;
              width: 85%;
            }
            .performanceLegendData{
              font-size: 12px;
              margin: 0;
            }
            .averageColorLegend{
              background-color: #ffa600;
              width: 8px;
              height: 8px;
              margin-top: 5px;
            }
            .topicLegendDiv{
              display: flex;
              flex-direction: row;
              margin: 0 5px;
            }
            .topicAnalysis{
              overflow: hidden auto;
              width: 100%;
              position: absolute;
              margin-top: 20px;
              border-radius: 5px;
              padding: 10px;
              margin-bottom: 40px;
            }
            .analysisLegendHeading{
              position: absolute;
              width: 95%;
              overflow-x:hidden;
              overflow-y: scroll;
            }
            .chartDiv{
              padding: 10px; 
              position: relative;
              margin-top: 150px;
              overflow: auto;
              width: ${chartWidth};
              height: 100%;
              white-space: nowrap;
              border-radius: 5px;
              overflow-x: auto;
            }
            .legendColor{
              width: 8px;
              height: 8px;
              margin-top: 5px;
            }
            .legendColorWidth{
              width: 5%;
            }
            .legendDataWidth{
              width: 90%;
            }
            .correct{
              background-color: #328c44;
            }
            .incorrect{
              background-color: #e65555;
            }
            .average{
              background-color: #ffa600;
            }
            .legendDetails{
              font-size: 12px;
              margin: 0;
            }
            .timeAnalysisLegend{
              display: flex;
              flex-direction: row;
              margin: 0 5px 0 50px;
            }

            .timeAnalysis{
              margin: 10px;
              overflow: auto;
              background-color: white;
              -webkit-overflow-scrolling: touch;
            }
            #ct-chart{
                font-family: sans-serif;
                stroke-dasharray: none;
                }
                #ct-chart .ct-grid {
                  stroke-dasharray: none;
                }
                #ct-chart2 .ct-grid {
                  stroke-dasharray: none;
                }
                .ct-series-a .ct-line {
                  /* Set the colour of this series line */
                  stroke: #00000066;
                  /* Control the thikness of your lines */
                  stroke-width: 1px;
                }
                .ct-series-a .ct-bar {
                    /* Colour of your bars */
                    stroke:  #216381;
                    stroke-width: 8;
                    
                  }
                .ct-series-b .ct-bar {
                    /* Colour of your bars */
                    stroke:  #ffa600;
                    stroke-width: 8;
                    
                  }
                .ct-series-a .ct-point {
                  /* Colour of your points */
                  stroke: green;
                  /* Size of your points */
                  stroke-width: 5px;
                }
                .ct-grid {
                  stroke: rgba(23, 2, 2, 0.94);
                  stroke-width: 1.5px;
                }
                .ct-label {
                  font-size: 10px;
                  text-align: center;
                }
    
                .ct-chart .ct-label.ct-horizontal.ct-end {
                  position: relative;
                  justify-content: left;
                  white-space:nowrap;
                }
                .ct-axis-title {
                  //  color: #FFFFFF !important;
                    font-family: sans-serif;
                    // font-weight: 200; 
                  }
          `}

        </style>
          
      </div>

    )
  }
}

export default TestAnalysis;